import { Box, TextField, Typography } from '@mui/material';

function ColorPicker({ label, value, onChange }) {
  return (
    <Box sx={{ flex: 1 }}>
      <Typography gutterBottom>{label}</Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1,
            bgcolor: value,
            border: '2px solid',
            borderColor: 'grey.300',
          }}
        />
        <TextField
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{
            width: '100%',
            '& input': {
              cursor: 'pointer',
              height: '40px',
              p: 0,
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default ColorPicker;
